import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import common from "../assets/css/common.module.css";
import { NavLink } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { postData1 } from "../../services";
import { Pagination } from "../Common";
import { FaArrowUp, FaArrowDown } from "react-icons/fa"; // Sorting icons

export const RequestList = () => {
  const [requestlistData, setRequestListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [perPage, setPerPage] = useState(8);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
  };

  const sortData = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const sortedData = [...requestlistData].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setRequestListData(sortedData);
  };

  useEffect(() => {
    (async () => {
      const config = { _page: currPage, _limit: perPage };
      const res = await postData1(
        "admin/requirementform_list/",
        config,
        true,
        true
      );
      setRequestListData(res?.data?.data);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
      setLoader(false);
    })();
  }, [currPage, perPage]);

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>REQUIREMENTS MANAGEMENT</h1>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => sortData("id")}>
            ID {sortConfig.key === "id" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("email")}>
            EMAIL {sortConfig.key === "email" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("contact_no")}>
            CONTACT {sortConfig.key === "contact_no" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("location")}>
            CITY {sortConfig.key === "location" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("category_list")}>
            EQUIPMENT {sortConfig.key === "category_list" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("price_range")}>
            PRICE RANGE {sortConfig.key === "price_range" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("condition")}>
            CONDITION {sortConfig.key === "condition" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span onClick={() => sortData("status")}>
            STATUS {sortConfig.key === "status" && (sortConfig.direction === "asc" ? <FaArrowUp /> : <FaArrowDown />)}
          </span>
          <span>DETAIL</span>
        </div>

        {requestlistData.map((data, index) => {
          return (
            <div className={styles.itemData} key={index}>
              <span>{data?.id}</span>
              <span>{data?.email}</span>
              <span>{data?.contact_no}</span>
              <span>{data?.location}</span>
              <span>{data?.category_list}</span>
              <span>{data?.price_range}</span>
              <span>
                {data?.condition === 1
                  ? "Preowned"
                  : data?.condition === 2
                  ? "NEW"
                  : data?.condition === 3
                  ? "SPARE/ACCESS"
                  : data?.condition === 4
                  ? "SERVICES"
                  : ""}
              </span>
              <span>
                <span className={common.customStyle}>UNRESOLVED</span>
              </span>
              <span>
                <NavLink to="view-manage-request/" state={{ item: data }}>
                  View
                </NavLink>
              </span>
            </div>
          );
        })}
      </div>
      <Pagination
        total={paging?.total}
        perPage={perPage}
        currPage={currPage}
        setCurrPage={setCurrPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
        setPerPage={setPerPage}
      />

      {loader && <Loader />}
    </section>
  );
};
